import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { Button, Modal } from "antd";

interface EmailReceiversModalProps extends WithTranslation {
  getFormFieldValues: () => API_MailRequest;
  render: (
    state: { to: string[]; cc: string[]; bcc: string[] },
    data: (API_Contact | API_Group)[],
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  ) => JSX.Element[];
  data: API_Contact[] | API_Group[];
  onSave: (fields: { to: string[]; cc: string[]; bcc: string[] }) => void;
  modalTitle: string;
  isVisible: boolean;
  onCancel: () => void;
}

interface EmailReceiversModalState {
  to: string[];
  cc: string[];
  bcc: string[];
}

export const EmailReceiversModal = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<EmailReceiversModalProps, EmailReceiversModalState> {
    constructor(props: EmailReceiversModalProps) {
      super(props);
      this.state = {
        to: [],
        cc: [],
        bcc: [],
      };
    }

    componentDidUpdate(prevProps: EmailReceiversModalProps) {
      if (this.props.isVisible && !prevProps.isVisible) {
        const values = this.props.getFormFieldValues() || {};
        this.setState({
          to: values.to || [],
          cc: values.cc || [],
          bcc: values.bcc || [],
        });
      }
    }

    isArray = (type: "to" | "cc" | "bcc", value: string) => {
      const currState = [...this.state[type].filter((elem) => elem !== value)];
      return currState.length ? currState : [];
    };

    handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const currCheckValue = e.target.value;
      const type = e.target.id as "to" | "cc" | "bcc";
      if (!this.state[type]) {
        this.setState((prevState) => ({ ...prevState, [type]: [currCheckValue] }));
        // this.setState({ [type]: [currCheckValue] } as any as EmailReceiversModalState);
      } else {
        this.state[type].indexOf(currCheckValue) !== -1
          ? this.setState((prevState) => ({ ...prevState, [type]: this.isArray(type, currCheckValue) }))
          : this.setState((prevState) => ({ ...prevState, [type]: [...this.state[type], currCheckValue] }));
      }
    };

    handleSave = () => {
      const { to, cc, bcc } = this.state;
      this.props.onSave({ to, cc, bcc });
    };

    render() {
      const { t, isVisible, onCancel, modalTitle } = this.props;
      return (
        <Modal
          title={modalTitle}
          footer={null}
          open={isVisible}
          destroyOnHidden={true}
          maskClosable={false}
          onCancel={onCancel}
          wrapClassName="groups-modal"
          zIndex={1012}
        >
          <div style={{ overflow: "auto", maxHeight: "300px", minHeight: "150px", paddingBottom: 45 }}>
            {this.props.render(this.state, this.props.data, this.handleCheckboxChange)}
          </div>
          <ButtonsRow>
            <Button type="primary" loading={false} onClick={this.handleSave} style={{ width: 183 }}>
              {t("Save")}
            </Button>
          </ButtonsRow>
        </Modal>
      );
    }
  }
);
